import React from "react";
const ErrorComponent = props => (<div className="default-component error">
		<div className="error-main">
			<span className="error-main-icon"></span>
		</div>
		<span className="default-message">Something went wrong</span>
		<span className="default-action-error">Try again</span>
	</div>);
export default ErrorComponent;
